<template>
    <section class="subscribe-section">
        <div class="container">
            <div class="subscribe-section--inner">
                <form action="POST" class="subscribe-form">
                    <div class="subscribe-form__title-box">
                        <h3 class="title">Get in Touch</h3>
                        <button type="submit" class="btn-submit"><button-arrow-icon/></button>
                    </div>
                    <div class="subscribe-form__main-box">
                        <div class="form-group">
                            <label for="email" class="form-label">Email</label>
                            <input type="text"  class="form-input" id="email" name="email" />
                        </div>
                        <div class="form-group">
                            <label for="phone" class="form-label">Phone</label>
                            <input type="text"  class="form-input" id="phone" name="phone" />
                        </div>
                        <div class="form-group">
                            <label for="address" class="form-label">Address</label>
                            <input type="text"  class="form-input" id="address" name="address" />
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </section>
</template>
